export class ListRestoreAwsOrganizationalUnitsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnits",
            "baseName": "organizationalUnits",
            "type": "Array<RestoreAwsOrganizationalUnit>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreAwsOrganizationalUnitsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
